// extracted by mini-css-extract-plugin
export var frame = "Frame-module--frame--92e8c";